const INITIAL_STATE_MODAL_POPUP = {
    data:{
        carbon : {
            image : "",
            title:"",
            download_link: ""
        },
        webtrail : {
            image : "",
            title:"",
            download_link: ""
        },
        comtrail : {
            image : "",
            title:"",
            download_link: ""
        },
        comtrailnx : {
            image : "",
            title:"",
            download_link: ""
        },
        feedback : {
            image : "",
            title:"FeedBack",
            download_link: ""
        },
        requestdemo : {
            image : "",
            title:"You are about to submit a request for Product Demonstration.",
            download_link: "CARBON || DEMO"
        },
        datacontent: {
            popupname : "datacontent",
            content : ""
        }
    },
    open:false,
    popupname:"",
    datatrack: 1
}
const ModalPopupBucket = (state = INITIAL_STATE_MODAL_POPUP, action) => {
     var statedata = action.payload;
     var key;
     var newdata;
     switch(action.type){
        case "SHOW_POPUP_DIRECT":
            /**********Show popup direct without user click*******/
            key = statedata.popupname;
            newdata = { ...state.data, [key]: statedata };
            return {
                ...state,
                data: newdata,
                open: true,
                popupname: key,
                datatrack: 0
            }
        case "SHOW_POPUP_BY_POPUP_NAME":
            /********Show popup by popup name which calling from websocket or by which popup nane in DOM********/
            key = statedata.popupname;
            return {
                ...state,
                open: true,
                popupname: key,
            }
        case "PUSH_POPUP_DATA":
            /********Push selected popup data by popup name which calling from websocket********/
            key = statedata.popupname;
            newdata = { ...state.data, [key]: statedata };
            return {
                ...state,
                data: newdata,
                open: false,
                popupname: "",
                datatrack: 0
            }
        case "PUSH_ALL_POPUP_DATA":
            /**********Get popup data from database and push in bucket while load website**********/
            // var key = statedata.popupname;
            // var newdata = { ...state.data, statedata };
            //console.log(statedata, 'inner all popupdata');
            return {
                ...state,
                data: statedata,
                open: false,
                popupname: "",
                datatrack: 0
            }
        case "HIDE_POPUP":
            return {
                ...state,
                open: false,
                popupname: "",
            }
        default:
            return state
    }
}

export default ModalPopupBucket;